import { dialogPortal } from '@/modules/common/helpers/portal';
import { MembershipTermsModal } from '.';

export const confirmMembershipTerms = async () =>
  dialogPortal(MembershipTermsModal);
